// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__BaLdx","footer":"ModalCreateQualiphyProcedure_footer__2jjnC","additionData":"ModalCreateQualiphyProcedure_additionData__11oxE"};